import { MenuItem } from 'primeng/api';
import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { MessagesService } from '@core/_services/messages.service';
import * as delegateTools from './../delegate.tools';
import { RequestTools } from '@service/request.tools';
import { CheckTools } from '@service/check.tools';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-add-delegate',
    templateUrl: './add-delegate.component.html',
    styleUrls: ['./add-delegate.component.scss'],
})
export class AddDelegateComponent implements OnInit {

    @Input()
    public fromUser = [];

    @Input()
    public toUser = [];

    @Output()
    public onCancel: EventEmitter<any> = new EventEmitter();

    @Output()
    public onValidate: EventEmitter<any> = new EventEmitter();


    public items: Array<MenuItem>;

    constructor(protected _messageService: MessagesService, private requestTools: RequestTools,
            private checkTools: CheckTools,private translate: TranslateService) {
    }

    ngOnInit() {
    }

    public async validate(result) {
        let wRes: any;
        wRes = await delegateTools.updateDelegate(result, this);

        this.onValidate.emit({
            data: wRes.data.UserList,
        });
    }

    cancel() {
        this.onCancel.emit({ id: null });
    }
}
